import { render, staticRenderFns } from "./CourseMaterials.vue?vue&type=template&id=3a03e752"
import script from "./CourseMaterials.vue?vue&type=script&lang=js"
export * from "./CourseMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports